import React from 'react';

const MetricSection = ({ id, index, title, titleZh, summary, summaryZh, children, isZh = false }) => (
    <section id={id} className="ai-dev-section" data-testid="ai-development-module">
        <div className="ai-dev-section__intro">
            <span className="ai-dev-section__number">{index}</span>
            <div>
                <div className="ai-dev-section__kicker">{String(index).padStart(2, '0')} / 05</div>
                <h2>{isZh ? titleZh : title}</h2>
                <p>{isZh ? summaryZh : summary}</p>
            </div>
        </div>
        {children}
    </section>
);

export default MetricSection;
